import { Textarea as UnionTextarea } from '@xo-union/tk-component-fields';
import { FieldProps, getIn, useFormikContext } from 'formik';
import React from 'react';
import { sanitizeHtml } from './common';
import { AiButton, buildField } from '../../../components/AiButton/AiButton';
import styles from './textArea.scss';

interface TextareaProps extends FieldProps {
  showAiButton: boolean;
  onChange?: (event: any) => void;
}

export const Textarea: React.FC<TextareaProps> = props => {
  const {
    field,
    showAiButton = false,
    form: { touched, errors, setFieldTouched, values },
    onChange,
    ...rest
  } = props;
  const { setFieldValue } = useFormikContext();
  const [isFocused, setIsFocused] = React.useState<boolean>(false);

  const fieldTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  let text;
  if (fieldTouched && error) {
    text = error;
  }

  const handleChange = (event: any) => {
    setFieldValue(field.name, sanitizeHtml(event.target.value));

    // Call the optional onChange prop if provided
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={`${styles.textAreaContainer} ${error && styles.invalid}`}>
      <UnionTextarea
        {...field}
        {...rest}
        state={fieldTouched && error ? 'invalid' : 'neutral'}
        subText={text}
        value={field.value}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setFieldTouched(field.name);
          setIsFocused(false);
        }}
        onChange={handleChange}
      />
      {showAiButton && (
        <AiButton
          className={styles.aiButtonPosition}
          field={buildField(field, setFieldValue, values)}
          isParentFocused={isFocused}
        />
      )}
    </div>
  );
};
